import { render } from "./NoResultsBox.vue?vue&type=template&id=4982446c"
import script from "./NoResultsBox.vue?vue&type=script&lang=js"
export * from "./NoResultsBox.vue?vue&type=script&lang=js"

import "./NoResultsBox.vue?vue&type=style&index=0&id=4982446c&lang=scss"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__